
import { computed, defineComponent, nextTick, onUnmounted, reactive, ref, watch } from "vue";
import { BaseLayout, OrderTravel } from "@/components/Common";
import { ZFS } from "@/config/env";

import {
  TaskWorkDetail,
  RemindOrder,
  GetTractRecord,
  CheckMerchantBillCodeWithBillInfo,
  ShowWorkOrderDetail,
} from "@/api-server/modules/defaultServer";
import { useRoute } from "vue-router";
import {
  getStoreMapWithDicKey,
  mapValueFormat,
  momentFormat,
} from "@/utils/formatter";
import { emitter, SYS_CLOSE_NAV_TAB, SYS_WORK_CODES } from "@/plugin/emitter";
import { useDynamicDialog } from "@/hooks";
// import { ArrowLeftBold, ArrowRightBold } from "@element-plus/icons"
import { RootState } from "@/@types/store";
import { useStore } from "vuex";
import { MediaList } from "@/components/Common"
import {array2Obj, zcatPoint} from "@/utils/utilFuns";

import progressList from "./components/progress-list.vue"

export default defineComponent({
  name: "OrderDetail",
  components: {
    BaseLayout,
    OrderTravel,
    MediaList,
    progressList,
  },

  setup() {
    const route = useRoute();
    const store = useStore<RootState>();
    const { getModelUUID, openModel } = useDynamicDialog();
    const loading = ref(false);
    const reminding = ref(false);
    const detailData = ref<any>({});

    const showList = ref<any[]>([])
    const showIndex = ref(0)

    const showLen = computed(() => showList.value.length)
    emitter.on(SYS_WORK_CODES, (list) => {
      showList.value = list as any[]
      getData(route.query as any);
    });

    const handleReLaunch = async (billCode: string, operateType: string) => {
      // await CheckMerchantBillCodeWithBillInfo.fetch({
      //   billCode
      // })
      operateType === 'restart' ?  zcatPoint(["售后管理", "重新激活", "售后详情"]) :  zcatPoint(["售后管理", "追加描述信息", "售后详情"]);

      const uuid = await getModelUUID("admin/after-sales-new/reLaunch");
      openModel(
        uuid,
        {
          formData: {
            ...detailData.value,
            workCode: route.query.workCode,
            operateType,
            pictureList: [],
            audioList: [],
            videoList: [],
            description: "",
          },
        },
        {
          updateSuccess() {
            getData(route.query as any);
          }
        }
      );
    };

    const dialog = reactive<{
      visible: boolean;
      loading: boolean;
      orderInfo: BUSINESS_SERVE_PLATFORM_PC.GetTractRecordResponseDataItem;
    }>({
      visible: false,
      loading: false,
      orderInfo: {},
    });

    const handleClick = async (billCodes: string) => {
      dialog.visible = true;
      dialog.loading = true;
      const {
        data: { data: billDataList },
      } = await GetTractRecord.fetch({
        billCodes: [billCodes],
      });
      dialog.loading = false;
      billDataList &&
        billDataList.length > 0 &&
        (dialog.orderInfo = billDataList[0])
    };

    const getData = async (
      body: BUSINESS_SERVE_PLATFORM_PC.ShowWorkOrderDetailRequestBody
    ) => {
      showIndex.value = showList.value.findIndex(v => v.workCode == route.query.workCode)
      if (showIndex.value == -1 && showList.value.length > 0) return
      if (loading.value) return
      loading.value = true
      const {
        data: { data },
      } = await ShowWorkOrderDetail.fetch({
        workCode: body.workCode,
      }).finally(() => {
        loading.value = false
      })
      detailData.value = data;
      await nextTick()
      handleClick(data?.billCode || '')
    };

    watch(route, (n) => {
      if (n.path === '/admin/after-sales/order-detail') {
        getData(n.query as any);
      }
    }, {
      immediate: true
    })

    onUnmounted(() => {
      emitter.off(SYS_WORK_CODES)
    })

    // onMounted(() => {
    //   getData(route.query as any);
    // });

    return {
      mapValueFormat,
      momentFormat,
      getStoreMapWithDicKey,
      detailData,
      loading,
      route,
      reminding,
      handleReLaunch,
      handleClick,
      dialog,
      showList,
      showLen,
      showIndex,
      array2Obj,
      ZFS,
    };
  },
});
